module.exports = __webpack_public_path__ + "img/saintbrand-shipping.f30c2f4b.png";